'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MINUTES = exports.MINUTES = 'MINUTES';
var HOURS = exports.HOURS = 'HOURS';
var DAYS = exports.DAYS = 'DAYS';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/typical-response-time/constants/Units.js
// module id = 578
// module chunks = 2 3